import api from '../../services/api';

async function getCardData() {
	const response = await api<string>('GET', 'debit/carddata');
	return response;
}

async function deleteCardData(payload: { imponible: string; tipo: string }) {
	return await api<string>('POST', 'debit/carddata-delete', payload);
}

const debitAPI = {
	getCardData,
	deleteCardData
};

export default debitAPI;
